// extracted by mini-css-extract-plugin
export default {"cls1":"MnOPTOiNZdIhgZcDQwaZ","cls2":"HPUU4HlZiS4HtrjaRy93 MnOPTOiNZdIhgZcDQwaZ","isPhone":"UKs1rwvGSs8iJGEs8cGC"};